<fieldset [disabled]="isLoading$().show" class="h-100">
  <div class="home-parent-container">
    <ng-container
      *ngIf="!(stateSignal$().workflow?.subscription.workflowData?.length > 0)"
    >
      <img src="/assets/img/hands.png" />
      <div class="col-lg text-center">
        <h4><strong>Welcome to PostGenie!</strong></h4>
        Your personal <strong>LinkedIn post assistant</strong> that works to
        <br />
        enhance creativity and brand conformance.
      </div>
      <div (click)="createNewWorkflow()">
        <button
          class="btn btn-primary input-element button-bottom"
          type="submit"
        >
          + Create new post
        </button>
      </div>
    </ng-container>
  </div>

  <div>
    <ng-container
      *ngIf="stateSignal$().workflow?.subscription.workflowData?.length > 0"
    >
      <ng-container *ngIf="stateSignal$().workflow?.subscription as sub">
        <div class="home-header-button">
          <div class="home-headline">Your LinkedIn posts</div>

          <div (click)="createNewWorkflow()">
            <button
              class="btn btn-primary input-element button-bottom"
              type="submit"
            >
              + Create new post
            </button>
          </div>
        </div>
        <div class="workflow-container">
          <ng-container *ngFor="let workflow of sub.workflowData">
            <div
              [ngClass]="{
                opacity:
                  isLoading$().show &&
                  stateSignal$().workflow?.subscription.workflowData?.length ==
                    0,
                'no-opacity': !(
                  isLoading$().show &&
                  stateSignal$().workflow?.subscription.workflowData?.length == 0
                )
              }"
            >
              <div class="workflow-box" (click)="openWorkflow(workflow)">
                <div class="level-one text-center">
                  <img
                    [ngClass]="{
                      opacity: !(
                        stateSignal$().workflow?.subscription.promptVersion ===
                        workflow.promptVersion
                      ),
                      'no-opacity':
                        stateSignal$().workflow?.subscription.promptVersion ===
                        workflow.promptVersion
                    }"
                    src="/assets/img/default_post.png"
                    alt="{{ workflow.name }}"
                  />
                </div>
                <div class="level-two">
                  <div
                    [matTooltip]="
                      stateSignal$().workflow?.subscription.promptVersion ===
                        workflow.promptVersion &&
                      stateSignal$().workflow?.subscription.promptVersion ===
                        workflow.promptVersion
                        ? 'Generated with PostGenie ' + workflow.promptVersion
                        : 'Inactive post (' +
                          workflow.promptVersion +
                          '). View post or generate a new post.'
                    "
                  >
                    {{ workflow.promptVersion }}
                  </div>
                </div>
              </div>
              <div class="grid">
                <div class="workflow-label" (click)="openWorkflow(workflow)">
                  {{ workflow.name }}
                </div>
                <div>
                  <button class="edit-button" [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="openWorkflow(workflow)">
                      <ng-container
                        *ngIf="
                          stateSignal$().workflow?.subscription.promptVersion ==
                          workflow.promptVersion
                        "
                      >
                        <mat-icon>edit</mat-icon>
                        <span>Edit post</span>
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !(
                            stateSignal$().workflow?.subscription
                              .promptVersion == workflow.promptVersion
                          )
                        "
                      >
                        <mat-icon>pageview</mat-icon>
                        <span>View post</span>
                      </ng-container>
                    </button>
                    <button mat-menu-item (click)="deleteWorkflow(workflow)">
                      <mat-icon>delete</mat-icon>
                      <span>Delete post</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</fieldset>
